"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureFlag = void 0;
const use_feature_flag_context_1 = require("../hooks/use-feature-flag-context");
const FeatureFlag = ({ name, not, children, }) => {
    const { isEnabled } = (0, use_feature_flag_context_1.useFeatureFlagContext)();
    const isEnableFeature = isEnabled(name);
    const isPass = (isEnableFeature && !not) || (!isEnableFeature && not);
    return isPass ? children : null;
};
exports.FeatureFlag = FeatureFlag;
